import { inject } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';
import { InternalRouterState } from './router.types';
import { Location } from '@angular/common';

export class CustomRouterSerializer implements RouterStateSerializer<InternalRouterState> {
  private _location: Location = inject(Location);

  serialize(routerState: RouterStateSnapshot): InternalRouterState {
    const navigationState = this._location.getState() || {};

    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const { params } = route;
    const { queryParams } = routerState.root;
    const { url } = routerState;

    return { params, queryParams, url, navigationState };
  }
}
